import { useCallback, useState } from 'react';
import { Box } from 'reflexbox';

import { useEnsureSupportAssociatedIdentitiesMutation } from '@treams/treams-network';
import { Button } from '@treams/treams-ui';

import AssociatedIdentities from '../employees/AssociatedIdentities';
import { WorkspaceAdvanced } from './types';

export default function WorkspaceSupport(props: { workspace: WorkspaceAdvanced }) {
	const [associatedIdentities, setAssociatedIdentities] = useState(
		props.workspace.user?.associatedIdentities.map((identity) => ({
			identityProviderID: identity.identityProvider.id,
			name: identity.name,
		})) ?? [],
	);
	const [ensure] = useEnsureSupportAssociatedIdentitiesMutation();

	const user = props.workspace.user;

	const save = useCallback(() => {
		if (!user) return;

		return ensure({
			variables: {
				input: {
					names: associatedIdentities.map(({ name }) => name),
					userID: user.id,
					workspaceID: props.workspace.id,
				},
			},
		});
	}, [user, ensure, associatedIdentities, props.workspace.id]);

	if (!user) return null;

	return (
		<Box flexGrow={1} flexBasis={0} mt="30px">
			<AssociatedIdentities
				username={user.username}
				email={user.email}
				associatedIdentities={associatedIdentities}
				setAssociatedIdentities={setAssociatedIdentities}
			/>
			<Button
				onClick={save}
				small
				title="Opslaan"
				type="primary"
				flexGrow={0}
				flexShrink={0}
				mt={1}
			/>
		</Box>
	);
}
